module.exports = __webpack_public_path__ + "img/slogan.9a014b96.png";